import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalViewPricingDetailsService {

    constructor() { }

    public visibleModal: boolean = false;

    showModal() {
        this.visibleModal = true;
    }

    hideModal() {
        this.visibleModal = false;
    }
}
